import { render, staticRenderFns } from "./ViqMarketEntry.vue?vue&type=template&id=2484ee78&scoped=true"
import script from "./ViqMarketEntry.vue?vue&type=script&lang=js"
export * from "./ViqMarketEntry.vue?vue&type=script&lang=js"
import style0 from "./ViqMarketEntry.vue?vue&type=style&index=0&id=2484ee78&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484ee78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2484ee78')) {
      api.createRecord('2484ee78', component.options)
    } else {
      api.reload('2484ee78', component.options)
    }
    module.hot.accept("./ViqMarketEntry.vue?vue&type=template&id=2484ee78&scoped=true", function () {
      api.rerender('2484ee78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqMarketEntry.vue"
export default component.exports